import { createAsyncThunk } from '@reduxjs/toolkit';

const getParams = (filters, row) => {
  const params = {
    filter_by: {
      date: {
        from: filters?.from,
      },
    },
    date_group: filters?.date_group,
    group_by_1: filters?.group_by,
    group_by_2: filters?.break_down,
  };

  if (row && row.subRows && row.subRows.length > 0) {
    delete params.group_by_2;
  }

  if (filters?.to) {
    params['filter_by']['date']['to'] = filters?.to;
  }

  if (filters?.c_to || filters?.c_from) {
    if (filters?.c_to) {
      const compare = {
        date: {
          to: filters?.c_to,
        },
      };
      params['compare'] = compare;
    }
    if (filters?.c_from) {
      const compare = {
        date: {
          from: filters?.c_from,
        },
      };
      params['compare'] = compare;
    }
  }

  if (filters?.recruiter_id?.length) {
    const ids = filters?.recruiter_id?.map((r) => r?.id);
    const condition = filters?.recruiter_id_condition?.id;
    params.filter_by['recruiter_id'] = {
      [condition]: ids,
    };
  }

  if (filters?.flow_id?.length) {
    const ids = filters?.flow_id?.map((r) => r?.id);
    const condition = filters?.flow_id_condition?.id;
    params.filter_by['flow_id'] = {
      [condition]: ids,
    };
  }

  if (filters?.department_id?.length) {
    const ids = filters?.department_id?.map((r) => r?.id);
    const condition = filters?.department_id_condition?.id;
    params.filter_by['ats_department_id'] = {
      [condition]: ids,
    };
  }

  if (filters?.job_id?.length) {
    const ids = filters?.job_id?.map((r) => r?.id);
    const condition = filters?.job_id_condition?.id;
    params.filter_by['ats_job_id'] = {
      [condition]: ids,
    };
  }

  return params;
};

const getCandidateTouchpoint = async (payload = {}, { extra: { http } }) => {
  try {
    const { filters } = payload;
    const params = getParams(filters);
    const result = await http.post('/reports/flow_health', params);
    return result?.data;
  } catch {}
};

export const fetchCandidateTouchpoint = createAsyncThunk(
  'reportsv2/candidatetouchpoint',
  getCandidateTouchpoint
);

export const getDrilldownParams = (selected) => {
  const {
    id: metric,
    row: { depth = 0, original: row },
  } = selected;

  const params = {};
  params['metric'] = metric;
  if (row?.type === 'chart') {
    params['dt'] = row?.dt;
    params['g1'] = row?.g1;
  } else {
    if (row?.g1 !== null) {
      params['g1'] =
        depth === 0
          ? row?.group_by?.id || row?.group_by
          : row?.parent?.id || row?.parent;
    } else {
      params['dt'] =
        depth === 0
          ? row?.group_by?.id || row?.group_by
          : row?.parent?.id || row?.parent;
    }

    if (row?.g2 !== null) {
      params['g2'] = row?.group_by?.id || row?.group_by;
    }
  }

  return params;
};

const getCandidateTouchpointDrilldown = async (
  payload = {},
  { extra: { http } }
) => {
  try {
    const {
      filters,
      selected,
      filterParams,
      page = 1,
      item = 50,
      searchTerm = '',
      sort_by_direction = 'asc',
    } = payload;

    const newParams = filterParams
      ? filterParams
      : getParams(filters, selected?.row);
    const drilldown = getDrilldownParams(selected);

    drilldown.page = page;
    drilldown.items = item;
    drilldown.sort_by_direction = sort_by_direction;

    if (searchTerm) {
      drilldown.search_term = searchTerm;
    }

    if (filters?.group_by) {
      newParams.group_by_1 = filters?.group_by;
    }
    if (filters?.break_down) {
      newParams.group_by_2 = filters?.break_down;
    }

    const result = await http.post('/reports/flow_health/drilldown', {
      ...newParams,
      drilldown,
    });
    return result?.data;
  } catch {}
};

export const fetchCandidateTouchpointDrilldown = createAsyncThunk(
  'reportsv2/candidatetouchpoint/drilldown',
  getCandidateTouchpointDrilldown
);
